<template>
  <div class="news-details">
    <Nav></Nav>
    <div class="news-details-content">
      <h1 class="news-title">{{ details.title }}</h1>
      <p class="news-date">{{ details.created_at }}</p>
      <div class="news-content" v-html="details.content"></div>
    </div>
  </div>
</template>

<script>
import Nav from '../components/Nav/index.vue'
export default {
  components: {
    Nav
  },
  data() {
    return {
      details: {
        title: '',
        created_at: '',
        content: ''
      },
      queryId: this.$route.query.id || '',
      loading: true,
      total: 0,
      queryParams: {
        page: 0,
        count: 10,
        scope: 'sketch'
      },
    };
  },
  created() {
    this.getNewsList();
    console.log('$route.query.id', this.$route.query.id)
  },
  methods: {
    getNewsList() {
      this.loading = true
      this.$axios.get('https://s.rendercool.com/api/v1/common/news/content?id='+this.$route.query.id)
        .then(response => {
          console.log(response.data)
          if (response.data.id) {
            this.details.title = response.data.title
            this.details.created_at = response.data.created_at
            this.details.content = response.data.html
          } else {
            this.$message.error(response.data.msg || '获取新闻详情失败');
          }
        })
        .catch(error => {
          console.error(error)
          this.$message.error(error.response.data.msg || '获取新闻详情失败');
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
.news-details {
  /* background-color: #161b1f; */
  font-size: 16px;
  line-height: 32px;
}
.news-details-content {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 120px;
}
.news-title {
  font-size: 30px;
  line-height: 1.4;
  margin-bottom: 14px;
  font-weight: 700;
  color: #09ccd8;
  text-align: center;
}
.news-date {
  color: #999;
  font-size: 14px;
  text-align: center;
}
.news-content {
  width: 100%;
  
}
.news-content :deep(h2) {
  font-size: 24px !important;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #09ccd8;
}

.news-content :deep(p img) {
  width: 100% !important; 
  height: auto;
  margin: 0 auto;
  display: block;
  margin-top: 20px;
  margin-bottom: 20px;
}
.news-content :deep(p) {
  margin-top: 20px;
  margin-bottom: 20px;
  text-indent: 2em;
}
.news-content :deep(a) {
  color: #09ccd8;
}
</style>